import script from "./GroupRemuneration.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupRemuneration.vue?vue&type=script&setup=true&lang=ts"

import "./GroupRemuneration.vue?vue&type=style&index=0&id=03790c1e&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03790c1e"]])

export default __exports__